import Sidebar from "../Sidebar/Sidebar";
import Header from "../Header/Header";

import "./AdminLayout.css";

export default function AdminLayout({ children }) {

    return (

        <div className="admin-layout">

            <Sidebar />

            <div className="admin-content">

                <Header />

                <main className="admin-page">

                    {children}

                </main>

            </div>

        </div>

    );

}